export type Parameter = {
  [key: string]: any;
  anyFunc?: (...args: any[]) => void;
};
